// extracted by mini-css-extract-plugin
export default {"success":"Success-module__success--WP0Vm","success__subtitle":"Success-module__success__subtitle--FCU5Y","success__description":"Success-module__success__description--UwPcf"};